<mat-sidenav-container autosize>
  <mat-sidenav
    class="side-nav"
    #sidenav
    role="navigation"
    [mode]="sideNavMode"
    [(opened)]="navState.opened"
  >
    <button
      *ngIf="navState.mobileView"
      class="button-style"
      id="sidenav-collapse-x"
      (click)="closeSidebar()"
    >
      <i class="fa-sharp fa-solid fa-xmark-large"></i>
      <span class="sr-only">Close sidebar</span>
    </button>
    <!-- <mat-checkbox id="sidenav-collapse" [(ngModel)]="opened">sidenav.opened</mat-checkbox> -->
    <!-- Make alt tag for this logo a property to be provided -->
    <img src="assets/logo-b-text.png" class="logo" [alt]="logoAlt" />
    <div>
      <mat-accordion>
        <mat-expansion-panel
          hideToggle
          class="mat-elevation-z"
          (opened)="expandPanel(panelIndex)"
          (closed)="expandedIndex = -1"
          *ngFor="let nav of navigators; let panelIndex = index"
          [expanded]="expandedIndex === panelIndex"
          [disabled]="!(nav.child && nav.child.length)"
        >
          <mat-expansion-panel-header
            appFocusWithin
            class="topLevelLink nav-color-focus"
            [class.active]="nav.route === currentLocation.url"
            *ngIf="!(nav.child && nav.child.length)"
          >
            <ng-container *ngIf="nav.external === false">
              <mat-panel-title
                (keydown.enter)="handleInternalLinkEnter(nav.route)"
                [routerLink]="nav.route"
                class="nav-color-focus"
                routerLinkActive="selected"
              >
                {{ nav.text }}
              </mat-panel-title>
            </ng-container>
            <ng-container *ngIf="nav.external === true">
              <mat-panel-title>
                <a
                  [href]="nav.route"
                  (keydown.enter)="handleLinkEnter(nav.route)"
                  class="full-block override-js-focus"
                  target="_blank"
                >
                  {{ nav.text }}
                </a>
              </mat-panel-title>
            </ng-container>
          </mat-expansion-panel-header>
          <mat-expansion-panel-header
            class="nav-color-focus"
            [expandedHeight]="'48px'"
            *ngIf="nav.child && nav.child.length"
          >
            <mat-panel-title>{{ nav.text }}</mat-panel-title>
            <mat-panel-description>
              <mat-icon *ngIf="expandedIndex !== panelIndex">add</mat-icon>
              <mat-icon *ngIf="expandedIndex === panelIndex">remove</mat-icon>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <ng-container *ngIf="nav.child && nav.child.length">
            <mat-expansion-panel
              class="subItem"
              (opened)="subExpandedIndex = subPanelIndex + panelIndex"
              (closed)="subExpandedIndex = -1"
              hideToggle
              class="mat-elevation-z nested-expansion-panel"
              color="primary"
              *ngFor="let child of nav.child; let subPanelIndex = index"
              [expanded]="true"
            >
              <mat-expansion-panel-header
                class="nav-color-focus"
                [expandedHeight]="'48px'"
                *ngIf="child.child && child.child.length"
              >
                <mat-panel-title>{{ child.text }}</mat-panel-title>
                <mat-panel-description>
                  <mat-icon *ngIf="subExpandedIndex !== subPanelIndex"
                    >add</mat-icon
                  >
                  <mat-icon *ngIf="subExpandedIndex === subPanelIndex"
                    >remove</mat-icon
                  >
                </mat-panel-description>
              </mat-expansion-panel-header>

              <mat-expansion-panel
                class="subItem"
                hideToggle
                class="mat-elevation-z nested-expansion-panel"
                color="primary"
                *ngFor="let nestedChild of child.child"
                [expanded]="true"
              >
                <div
                  *ngIf="nestedChild.external"
                  class="link-item"
                  style="height: 48px"
                >
                  <mat-panel-title>
                    <a
                      [href]="nestedChild.route"
                      class="override-js-focus"
                      target="_blank"
                      >{{ nestedChild.text }}</a
                    >
                  </mat-panel-title>
                </div>
                <div
                  *ngIf="nestedChild.external === false"
                  class="link-item"
                  style="height: 48px"
                >
                  <mat-panel-title
                    [class.active]="nestedChild.route === currentLocation.url"
                  >
                    <a
                      [routerLink]="nestedChild.route"
                      class="override-js-focus"
                      appFocusWithin
                      routerLinkActive="selected"
                    >
                      {{ nestedChild.text }}
                    </a>
                  </mat-panel-title>
                </div>
              </mat-expansion-panel>

              <div
                *ngIf="child.external && !child.child.length"
                class="link-item"
                style="height: 48px"
              >
                <mat-panel-title>
                  <a
                    [href]="child.route"
                    class="override-js-focus"
                    target="_blank"
                    >{{ child.text }}</a
                  >
                </mat-panel-title>
              </div>
              <div
                *ngIf="child.external === false && !child.child.length"
                class="link-item"
                style="height: 48px"
              >
                <mat-panel-title
                  [class.active]="child.route === currentLocation.url"
                >
                  <a
                    [routerLink]="child.route"
                    class="override-js-focus"
                    appFocusWithin
                    routerLinkActive="selected"
                  >
                    {{ child.text }}
                  </a>
                </mat-panel-title>
              </div>
            </mat-expansion-panel>
          </ng-container>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </mat-sidenav>
  <mat-sidenav-content>
    <app-header class="print-none" [navState]="navState"></app-header>
    <ng-content></ng-content>
  </mat-sidenav-content>
</mat-sidenav-container>
